<template>
    <Modal
        v-model="show"
        title="账号信息"
        :width="60"
        @on-visible-change="onShowChange"
    >
        <Spin v-if="innerSpin" size="large" fix></Spin>
        <Form
            ref="userCustomerManagerForm"
            :model="userCustomerManagerForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form"
        >
            <Row :gutter="18">
                <Col span="6">
                    <FormItem label="登录帐号" prop="userName">
                        <Input
                            v-model="userCustomerManagerForm.userName"
                            :readonly="formEditMode === FORM_EDIT_MODE_MODIFY"
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="姓名" prop="userCustomerManagerName">
                        <Input
                            v-model="
                                userCustomerManagerForm.userCustomerManagerName
                            "
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem
                        label="所属区域"
                        prop="userCustomerManagerAreaUuid"
                    >
                        <Select
                            v-model="
                                userCustomerManagerForm.userCustomerManagerAreaUuid
                            "
                            filterable
                        >
                            <Option
                                v-for="item in areaSource"
                                :key="item.areaUuid"
                                :value="item.areaUuid"
                                >{{ item.areaName }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="手机" prop="userCustomerManagerPhone">
                        <Input
                            v-model="
                                userCustomerManagerForm.userCustomerManagerPhone
                            "
                        ></Input>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="18">
                <Col span="6" v-if="formEditMode === FORM_EDIT_MODE_MODIFY">
                    <FormItem label="编号" prop="userCustomerManagerCode">
                        <Input
                            v-model="
                                userCustomerManagerForm.userCustomerManagerCode
                            "
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="审批" prop="userCustomerManagerApproval">
                        <RadioGroup
                            v-model="
                                userCustomerManagerForm.userCustomerManagerApproval
                            "
                            type="button"
                        >
                            <Radio
                                v-for="item in approvalSource"
                                :key="item.val"
                                :label="item.val"
                                >{{ item.label }}
                            </Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem
                        label="免试资格"
                        prop="userCustomerManagerPassAll"
                    >
                        <RadioGroup
                            v-model="
                                userCustomerManagerForm.userCustomerManagerPassAll
                            "
                            type="button"
                        >
                            <Radio :label="0">否</Radio>
                            <Radio :label="1">是</Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem
                        label="微信二维码"
                        prop="userCustomerManagerWechatFile"
                    >
                        <single-file-upload-with-name
                            v-model="
                                userCustomerManagerForm.userCustomerManagerWechatFile
                            "
                            :imgHeight="150"
                            :imgWidth="150"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="18">
                <!-- <Col span="6">
                    <FormItem label="公司" prop="company">
                        <Select
                            v-model="userCustomerManagerForm.companyUuid"
                            clearable
                            filterable
                        >
                            <Option
                                v-for="item in companyList"
                                :key="item.id"
                                :value="item.id"
                                >{{ item.name }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col> -->
                <Col span="6">
                    <FormItem label="部门" prop="department">
                        <Select
                            v-model="userCustomerManagerForm.departmentUuid"
                            clearable
                            filterable
                        >
                            <Option
                                v-for="item in departmentList"
                                :key="item.departmentUuid"
                                :value="item.departmentUuid"
                                >{{ item.departmentName }}-{{ item.departmentContact }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                
                <Col span="6">
                    <FormItem label="是否是市场部" prop="mktType">
                        <RadioGroup v-model="userCustomerManagerForm.mktType" type="button">
                            <Radio label="false">否</Radio>
                            <Radio label="true">是</Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="默认苗场(代下单)" prop="defaultSeedFarmUuid">
                        <Select
                            v-model="userCustomerManagerForm.defaultSeedFarmUuid"
                            clearable
                            filterable
                        >
                            <Option
                                v-for="item in seedFarmOptions"
                                :key="item.seedFarmUuid"
                                :value="item.seedFarmUuid"
                                >{{ item.seedFarmCode }}-{{ item.seedFarmName }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                
                <!-- Col span="6">
                    <FormItem label="归属" prop="belongTo">
                        <Select
                            v-model="userCustomerManagerForm.belongTo"
                            clearable
                            filterable
                        >
                            <Option
                                v-for="(item,index) in belongToList"
                                :key="index"
                                :value="item.value"
                                >{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Col> -->
                <!-- <Col span="6">
                    <FormItem
                        label="用友部门"
                        prop="userCustomerManagerYsDeptCode"
                    >
                        <Select
                            v-model="
                                userCustomerManagerForm.userCustomerManagerYsDeptCode
                            "
                            clearable
                            filterable
                            @on-select="onSelectYSDept"
                        >
                            <Option
                                v-for="item in YSDeptOptions"
                                :key="item.code"
                                :value="item.code"
                                >{{ item.code }}-{{ item.name }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col> -->
            </Row>
            <Row :gutter="18">
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE" span="6">
                    <FormItem label="密码">
                        <Input v-model="password" type="password"></Input>
                    </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE" span="6">
                    <FormItem label="密码确认">
                        <Input
                            v-model="passwordConfirm"
                            type="password"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>

        <!-- 服务区域 -->
        <div
            v-if="$checkAccessArray(['S']) && serviceAreaFormShow"
            style="margin-top: 15px"
        >
            <Divider orientation="left" size="small">服务区域</Divider>
            <Form :model="serviceAreaForm">
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="服务区域等级" prop="regionGrade">
                            <Select
                                v-model="serviceAreaForm.regionGrade"
                                @on-change="onRegionGradeChange"
                            >
                                <Option
                                    v-for="item in regionGradeList"
                                    :value="item.val"
                                    :key="item.val"
                                    >{{ item.label }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="18">
                    <Col span="6" v-if="serviceAreaForm.regionGrade == 1">
                        <FormItem label="" prop="provinceUuids">
                            <Select
                                v-model="serviceAreaForm.provinceUuids"
                                filterable
                                multiple
                                clearable
                                placeholder="请选择省"
                            >
                                <Option
                                    v-for="item in provinceOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col
                        span="6"
                        v-if="
                            serviceAreaForm.regionGrade == 2 ||
                            serviceAreaForm.regionGrade == 3
                        "
                    >
                        <FormItem label="" prop="provinceUuid">
                            <Select
                                v-model="serviceAreaForm.provinceUuid"
                                filterable
                                clearable
                                placeholder="请选择省"
                                @on-change="onProvinceChange"
                            >
                                <Option
                                    v-for="item in provinceOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6" v-if="serviceAreaForm.regionGrade == 2">
                        <FormItem label="" prop="cityUuids">
                            <Select
                                v-model="serviceAreaForm.cityUuids"
                                filterable
                                multiple
                                clearable
                                placeholder="请选择市"
                            >
                                <Option
                                    v-for="item in cityOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6" v-if="serviceAreaForm.regionGrade == 3">
                        <FormItem label="" prop="cityUuid">
                            <Select
                                v-model="serviceAreaForm.cityUuid"
                                filterable
                                clearable
                                placeholder="请选择市"
                                @on-change="onCityChange"
                            >
                                <Option
                                    v-for="item in cityOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6" v-if="serviceAreaForm.regionGrade == 3">
                        <FormItem label="" prop="regionUuids">
                            <Select
                                v-model="serviceAreaForm.regionUuids"
                                filterable
                                multiple
                                clearable
                                placeholder="请选择区/县"
                            >
                                <Option
                                    v-for="item in distOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="">
                            <Button type="primary" @click="addServiceArea"
                                >添加</Button
                            >
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="24">
                        <FormItem label="服务区域列表">
                            <Table
                                ref="regionTable"
                                size="small"
                                :columns="regionTable.columns"
                                :data="serviceAreaList"
                                stripe
                                border
                            />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>

        <div slot="footer">
            <Button
                type="primary"
                v-if="$checkAccessArray(['S', 'G'])"
                @click="onSave"
                >确认</Button
            >
            <Button type="error" @click="show = false">取消</Button>
        </div>
    </Modal>
</template>

<script>
import search from "@/libs/search";
import {
    APPROVAL_NO,
    APPROVAL_YES,
    approvalFormat,
    REGION_GRADE_PROVINCE,
    REGION_GRADE_CITY,
    REGION_GRADE_AREA,
    regionGradeFormat
} from "@/libs/baseModelFormat";
import { dateTimeRender } from "@/libs/tableRowTimeRender";
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";
import SingleFileUploadWithName from "@/components/single-file-upload-with-name/SingleFileUploadWithName";

import {
    customerManagerUserSave,
    getCustomerManagerUserDetail,
    pageInit4UserCustomerManagerEdit,
    getManagerRegionList,
    addManagerRegion,
    deleteManagerRegion
} from "@/api/modules/account-management/customerManager-user-management";
import { getYSDeptList, getUserSeedFarmList } from "@/api/modules/system-management/seedFarm-management";
import { webGetAllRegion } from "@/api/modules/system-management/region-management";

export default {
    name: "CustomerManagerUserEdit",
    components: {
        SingleFileUploadWithName
    },
    props: {
        departmentList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            // 服务区域表单显示状态
            serviceAreaFormShow: false,
            // 服务区域表单数据
            serviceAreaForm: {
                managerUuid: "",
                regionGrade: 3,
                provinceUuid: "",
                cityUuid: "",
                provinceUuids: [],
                cityUuids: [],
                regionUuids: []
            },
            belongToList:[
                {
                    value: 0,
                    label: "无"
                },
                {
                    value: 1,
                    label: "总监"
                },
                {
                    value: 2,
                    label: "客户经理项目人"
                }
                
            ],
            allRegions: [],
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            companyOptions: [],
            seedFarmOptions: [],
            deptOptions: [],
            serviceAreaList: [],
            show: false,
            innerSpin: false,
            accountUuid: "",
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userCustomerManagerForm: {
                userCustomerManagerLoginUuid: "",
                userName: "",
                userCustomerManagerName: "",
                userCustomerManagerAreaUuid: "",
                userCustomerManagerContactNumber: "",
                userCustomerManagerPhone: "",
                userCustomerManagerWechat: "",
                userCustomerManagerEmail: "",
                userCustomerManagerApproval: APPROVAL_NO,
                userCustomerManagerCode: "",
                userCustomerManagerPassAll: 0,
                userCustomerManagerWechatFile: "",
                userCustomerManagerYsDeptId: "",
                userCustomerManagerYsDeptCode: "",
                userCustomerManagerYsDeptName: "",
                companyUuid: "",
                defaultSeedFarmUuid: "",
                departmentUuid: "",
                mktType: "false",
                belongTo: 0
            },
            // 绑定信息
            bindInfo: {
                company: "",
                dept: ""
            },
            // 表单验证规则
            ruleValidate: {
                userName: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: this.validateUserName
                    }
                ],
                userCustomerManagerAreaUuid: [
                    { required: true, message: " ", trigger: "blur" }
                ],
                userCustomerManagerPhone: [
                    {
                        required: true,
                        message: "手机号码不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: this.validatePhoneNumber,
                        trigger: "change"
                    }
                ]
            },
            password: "",
            passwordConfirm: "",
            areaSource: [],
            approvalSource: [],
            regionGradeList: [],
            // 服务区域表格配置
            regionTable: {
                columns: [
                    { title: "省份", key: "provinceName", align: "center" },
                    { title: "城市", key: "cityName", align: "center" },
                    { title: "区县", key: "areaName", align: "center" },
                    {
                        title: "服务区域等级",
                        key: "regionGrade",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "span",
                                    {},
                                    regionGradeFormat(params.row.regionGrade)
                                )
                            ]);
                        }
                    },
                    {
                        title: "创建时间",
                        key: "createTime",
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.createTime)
                    },
                    {
                        title: "更新时间",
                        key: "modifyTime",
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.modifyTime)
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 120,
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small"
                                        },
                                        style: {
                                            display: this.$checkAccessArray([
                                                "S"
                                            ])
                                                ? "inline-block"
                                                : "none"
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteManagerRegion(
                                                    params.row
                                                );
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }
                ]
            },
            YSDeptOptions: []
        };
    },
    mounted() {
        this.init();
        this.getYSDeptList();
    },

    beforeDestroy() {
        // 清理定时器或事件监听器
    },
    methods: {
        // ==================== 表单验证相关方法 ====================

        /**
         * 验证用户名
         * @param {Object} rule 验证规则
         * @param {string} value 用户名
         * @param {Function} callback 回调函数
         */
        validateUserName(rule, value, callback) {
            if (!value) {
                callback(new Error(" "));
                return;
            }

            if (value.length < 3 || value.length > 20) {
                callback(new Error("长度在3-20个字符之间"));
                return;
            }

            callback();
        },

        /**
         * 验证手机号码
         * @param {Object} rule 验证规则
         * @param {string} value 手机号码
         * @param {Function} callback 回调函数
         */
        validatePhoneNumber(rule, value, callback) {
            if (!value) {
                callback();
                return;
            }

            const phoneRegex = /^(13[0-9]|14[1579]|15[0-3,5-9]|16[6]|17[0123456789]|18[0-9]|19[0-9])\d{8}$/;
            if (!phoneRegex.test(value)) {
                callback(new Error("手机号码格式不正确"));
                return;
            }

            callback();
        },

        // ==================== 服务区域管理方法 ====================

        /**
         * 服务区域等级变更处理
         */
        onRegionGradeChange() {
            // 清空相关联的地区选择
            this.resetServiceAreaForm();
        },

        /**
         * 重置服务区域表单
         */
        resetServiceAreaForm() {
            this.serviceAreaForm.provinceUuids = [];
            this.serviceAreaForm.cityUuids = [];
            this.serviceAreaForm.regionUuids = [];
            this.serviceAreaForm.provinceUuid = "";
            this.serviceAreaForm.cityUuid = "";
        },
        /**
         * 添加服务区域
         */
        addServiceArea() {
            if (!this.validateServiceAreaForm()) {
                return;
            }

            this.setLoadingState(true);

            addManagerRegion(this.serviceAreaForm)
                .then((res) => {
                    this.handleApiResponse(res, {
                        successTitle: "保存服务区域成功",
                        successCallback: () => {
                            this.getManagerRegionList(this.accountUuid);
                        }
                    });
                })
                .catch((error) => {
                    this.handleApiError(error, "添加服务区域失败");
                })
                .finally(() => {
                    this.setLoadingState(false);
                });
        },

        /**
         * 验证服务区域表单
         * @returns {boolean} 验证结果
         */
        validateServiceAreaForm() {
            const { provinceUuid, cityUuid, regionUuids, regionGrade } = this.serviceAreaForm;

            switch (regionGrade) {
                case REGION_GRADE_PROVINCE:
                    if (!provinceUuid) {
                        this.$Message.warning("请选择省份");
                        return false;
                    }
                    break;
                case REGION_GRADE_CITY:
                    if (!provinceUuid || !cityUuid) {
                        this.$Message.warning("请选择省份和城市");
                        return false;
                    }
                    break;
                case REGION_GRADE_AREA:
                    if (!provinceUuid || !cityUuid || !regionUuids.length) {
                        this.$Message.warning("请选择完整的省市区信息");
                        return false;
                    }
                    break;
            }

            return true;
        },
        // ==================== 通用工具方法 ====================

        /**
         * 设置加载状态
         * @param {boolean} isLoading 是否加载中
         */
        setLoadingState(isLoading) {
            this.innerSpin = isLoading;
        },

        /**
         * 处理API响应
         * @param {Object} response API响应对象
         * @param {Object} options 处理选项
         */
        handleApiResponse(response, options = {}) {
            const {
                successTitle = "操作成功",
                successCallback,
                showErrorMsg = true
            } = options;

            if (response.code === 0) {
                if (successTitle) {
                    this.$Modal.success({
                        title: successTitle,
                        onOk: successCallback || (() => {})
                    });
                }
                else if (successCallback) {
                    successCallback();
                }
            }
            else {
                if (showErrorMsg) {
                    this.$Message.error(response.message || "操作失败");
                }
            }
        },

        /**
         * 处理API错误
         * @param {Error} error 错误对象
         * @param {string} defaultMessage 默认错误信息
         */
        handleApiError(error, defaultMessage = "请求失败") {
            console.error("API请求异常:", error);
            this.$Message.error(defaultMessage + "，请稍后重试");
        },

        // ==================== 生命周期和事件处理 ====================

        /**
         * 模态框显示状态变更处理
         * @param {boolean} visible 是否显示
         */
        onShowChange(visible) {
            if (visible) {
                this.init();
            }
        },
        /**
         * 显示模态框
         * @param {string} accountUuid 账号UUID
         * @param {Array} company 公司信息
         * @param {Array} dept 部门信息
         */
        showModal(accountUuid, company = [], dept = []) {
            this.init();
            this.accountUuid = accountUuid;
            this.bindInfo.company = company;
            this.bindInfo.dept = dept;
            this.show = true;
        },
        // 初始化数据源
        initDataSources() {
            this.approvalSource = [
                { val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) },
                { val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) }
            ];

            this.regionGradeList = [
                { val: REGION_GRADE_PROVINCE, label: regionGradeFormat(REGION_GRADE_PROVINCE) },
                { val: REGION_GRADE_CITY, label: regionGradeFormat(REGION_GRADE_CITY) },
                { val: REGION_GRADE_AREA, label: regionGradeFormat(REGION_GRADE_AREA) }
            ];

            // 重置用户表单数据
            this.resetUserForm();
        },

        // ==================== 数据初始化方法 ====================

        /**
         * 初始化页面数据
         */
        init() {
            this.initDataSources();
            this.setLoadingState(true);

            // 并行加载多个数据源
            Promise.all([
                this.getRegionList(),
                this.loadPageData(),
                this.getUserSeedFarmList()
            ]).finally(() => {
                this.setLoadingState(false);
            });
        },

        /**
         * 初始化数据源
         */
        initDataSources() {
            this.initApprovalSource();
            this.initRegionGradeList();
            this.resetUserForm();
        },

        /**
         * 初始化审批状态数据源
         */
        initApprovalSource() {
            this.approvalSource = [
                { val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) },
                { val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) }
            ];
        },

        /**
         * 初始化区域等级数据源
         */
        initRegionGradeList() {
            this.regionGradeList = [
                { val: REGION_GRADE_PROVINCE, label: regionGradeFormat(REGION_GRADE_PROVINCE) },
                { val: REGION_GRADE_CITY, label: regionGradeFormat(REGION_GRADE_CITY) },
                { val: REGION_GRADE_AREA, label: regionGradeFormat(REGION_GRADE_AREA) }
            ];
        },

        /**
         * 重置用户表单数据
         */
        resetUserForm() {
            const defaultForm = {
                userCustomerManagerLoginUuid: "",
                userName: "",
                userCustomerManagerName: "",
                userCustomerManagerAreaUuid: "",
                userCustomerManagerContactNumber: "",
                userCustomerManagerPhone: "",
                userCustomerManagerWechat: "",
                userCustomerManagerEmail: "",
                userCustomerManagerApproval: APPROVAL_NO,
                userCustomerManagerCode: "",
                userCustomerManagerPassAll: 0,
                userCustomerManagerWechatFile: "",
                userCustomerManagerYsDeptId: "",
                userCustomerManagerYsDeptCode: "",
                userCustomerManagerYsDeptName: "",
                companyUuid: "",
                departmentUuid: "",
                mktType: "false",
                belongTo: 0,
                defaultSeedFarmUuid: ""
            };

            Object.assign(this.userCustomerManagerForm, defaultForm);
        },
        // ==================== 数据加载方法 ====================

        /**
         * 加载页面初始化数据
         * @returns {Promise} 加载Promise
         */
        loadPageData() {
            return pageInit4UserCustomerManagerEdit()
                .then((res) => {
                    if (res.code === 0) {
                        this.processAreaData(res.data.area.records);
                    }
                    else {
                        this.$Message.error(res.message || "页面数据加载失败");
                    }
                })
                .catch((error) => {
                    this.handleApiError(error, "页面数据加载失败");
                });
        },

        /**
         * 处理区域数据
         * @param {Array} areaRecords 区域记录
         */
        processAreaData(areaRecords) {
            this.areaSource = areaRecords.map((item) => ({
                areaUuid: item.areaUuid,
                areaName: item.areaName
            }));

            if (this.accountUuid) {
                this.handleEditMode();
            }
            else {
                this.handleCreateMode();
            }
        },

        /**
         * 处理公司数据
         * @param {Array} companyRecords 公司记录
         */
        processCompanyData(companyRecords) {
            this.companyOptions = companyRecords.map((item) => ({
                companyUuid: item.companyUuid,
                companyName: item.companyName
            }));
        },

        /**
         * 处理部门数据
         * @param {Array} departmentRecords 部门记录
         */
        processDepartmentData(departmentRecords) {
            this.departmentOptions = departmentRecords.map((item) => ({
                departmentUuid: item.departmentUuid,
                departmentName: item.departmentName
            }));
        },

        // ==================== 模式处理方法 ====================

        /**
         * 处理编辑模式
         */
        handleEditMode() {
            this.serviceAreaFormShow = true;
            this.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.serviceAreaForm.managerUuid = this.accountUuid;
            this.loadUserDetail();
            this.getManagerRegionList(this.accountUuid);
        },

        /**
         * 处理创建模式
         */
        handleCreateMode() {
            this.serviceAreaFormShow = false;
            this.serviceAreaList = [];
            this.$refs.userCustomerManagerForm.resetFields();
        },

        // ==================== 数据加载方法 ====================

        /**
         * 加载用户详细信息
         */
        loadUserDetail() {
            getCustomerManagerUserDetail(this.accountUuid)
                .then((detail) => {
                    if (detail.code === 0) {
                        const userData = { ...detail.data.userCustomerManager };

                        // 转换布尔值为字符串以适配 Radio 组件
                        if (userData.mktType === true || userData.mktType === false) {
                            userData.mktType = userData.mktType ? "true" : "false";
                        }

                        Object.assign(this.userCustomerManagerForm, userData);
                    }
                })
                .catch((error) => {
                    this.handleApiError(error, "加载用户详细信息失败");
                });
        },

        /**
         * 获取用户苗场列表
         * @returns {Promise} 加载Promise
         */
        getUserSeedFarmList() {
            const tableSearch = search.closeAllConditions(search.getSearchParams());

            return getUserSeedFarmList(tableSearch)
                .then((res) => {
                    if (res.code === 0) {
                        this.seedFarmOptions = res.data.seedFarmList;
                    }
                    else {
                        this.$Message.error(res.message || "获取苗场列表失败");
                    }
                })
                .catch((error) => {
                    this.handleApiError(error, "获取苗场列表失败");
                });
        },

        /**
         * 获取地区列表
         * @returns {Promise} 加载Promise
         */
        getRegionList() {
            return webGetAllRegion()
                .then((res) => {
                    if (res.code === 0) {
                        this.allRegions = res.data.allRegions;
                        this.provinceOptions = this.allRegions.filter(
                            (r) => r.regionType === 1
                        );
                        this.cityOptions = [];
                        this.distOptions = [];
                    }
                    else {
                        this.$Message.error(res.message || "获取地区列表失败");
                    }
                })
                .catch((error) => {
                    this.handleApiError(error, "获取地区列表失败");
                });
        },

        // ==================== 地区选择处理方法 ====================

        /**
         * 省份变更处理
         * @param {string} provinceUuid 省份UUID
         */
        onProvinceChange(provinceUuid) {
            this.serviceAreaForm.cityUuids = [];
            this.serviceAreaForm.regionUuids = [];
            this.distOptions = [];
            this.serviceAreaForm.cityUuid = "";

            this.cityOptions = this.allRegions.filter(
                (r) => r.regionType === 2 && r.regionParentUuid === provinceUuid
            );
        },

        /**
         * 城市变更处理
         * @param {string} cityUuid 城市UUID
         */
        onCityChange(cityUuid) {
            this.serviceAreaForm.regionUuids = [];

            this.distOptions = this.allRegions.filter(
                (r) => r.regionType === 3 && r.regionParentUuid === cityUuid
            );
        },
        // ==================== 服务区域管理方法 ====================

        /**
         * 获取管理员区域列表
         * @param {string} managerUuid 管理员UUID
         * @returns {Promise} 加载Promise
         */
        getManagerRegionList(managerUuid) {
            this.setLoadingState(true);

            return getManagerRegionList({ managerUuid: managerUuid })
                .then((res) => {
                    if (res.code === 0) {
                        this.serviceAreaList = res.data.records;
                    }
                    else {
                        this.$Message.error(res.message || "获取服务区域列表失败");
                    }
                })
                .catch((error) => {
                    this.handleApiError(error, "获取服务区域列表失败");
                })
                .finally(() => {
                    this.setLoadingState(false);
                });
        },

        /**
         * 删除管理员区域
         * @param {Object} row 区域行数据
         */
        deleteManagerRegion(row) {
            this.$Modal.confirm({
                title: "是否确认删除该服务区域？",
                onOk: () => {
                    this.setLoadingState(true);

                    deleteManagerRegion({
                        managerRegionUuid: row.managerRegionUuid
                    })
                        .then((res) => {
                            this.handleApiResponse(res, {
                                successTitle: "删除服务区域成功",
                                successCallback: () => {
                                    this.getManagerRegionList(row.managerUuid);
                                }
                            });
                        })
                        .catch((error) => {
                            this.handleApiError(error, "删除服务区域失败");
                        })
                        .finally(() => {
                            this.setLoadingState(false);
                        });
                }
            });
        },

        // ==================== 数据保存方法 ====================

        /**
         * 保存用户数据
         */
        onSave() {
            this.$refs.userCustomerManagerForm.validate((valid) => {
                if (!valid) {
                    this.$Message.error("表单验证失败!");
                    return;
                }

                const data = this.prepareSaveData();
                this.saveUserData(data);
            });
        },

        /**
         * 准备保存数据
         * @returns {Object} 准备好的数据对象
         */
        prepareSaveData() {
            const data = Object.assign(
                { formEditMode: this.formEditMode },
                this.userCustomerManagerForm
            );

            if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                data.password = this.password;
                data.passwordConfirm = this.passwordConfirm;
            }

            return data;
        },

        /**
         * 保存用户数据到服务器
         * @param {Object} data 用户数据
         */
        saveUserData(data) {
            this.setLoadingState(true);

            customerManagerUserSave(data)
                .then((res) => {
                    this.handleApiResponse(res, {
                        successTitle: "保存成功",
                        successCallback: () => {
                            this.show = false;
                            this.$parent.getCustomerManagerUserTableRecords();
                        }
                    });
                })
                .catch((error) => {
                    this.handleApiError(error, "保存用户数据失败");
                })
                .finally(() => {
                    this.setLoadingState(false);
                });
        },

        // ==================== YS部门相关方法 ====================

        /**
         * 获取YS部门列表
         */
        getYSDeptList() {
            getYSDeptList()
                .then((res) => {
                    if (res.code === 0) {
                        this.YSDeptOptions = res.data.deptList;
                    }
                    else {
                        this.$Message.error(res.message || "获取YS部门列表失败");
                    }
                })
                .catch((error) => {
                    this.handleApiError(error, "获取YS部门列表失败");
                });
        },

        /**
         * 选择YS部门
         * @param {string} row 部门代码
         */
        onSelectYSDept(row) {
            const matchedDept = this.YSDeptOptions.find(
                (item) => item.code === row
            );

            if (matchedDept) {
                this.userCustomerManagerForm.userCustomerManagerYsDeptId = matchedDept.id;
                this.userCustomerManagerForm.userCustomerManagerYsDeptName = matchedDept.name;
            }
        }
    }
};
</script>

<style scoped></style>
